import { render, staticRenderFns } from "./kvProject.vue?vue&type=template&id=b224ea90&"
import script from "./kvProject.vue?vue&type=script&lang=js&"
export * from "./kvProject.vue?vue&type=script&lang=js&"
import style0 from "./kvProject.vue?vue&type=style&index=0&id=b224ea90&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/kivateknoloji/kivacloud/corona-ux/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b224ea90')) {
      api.createRecord('b224ea90', component.options)
    } else {
      api.reload('b224ea90', component.options)
    }
    module.hot.accept("./kvProject.vue?vue&type=template&id=b224ea90&", function () {
      api.rerender('b224ea90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/kiva/remote-search/kvProject.vue"
export default component.exports